import { HiveLogo } from '../hive-logo';
import { useTheme } from 'next-themes';
import { type ReactNode } from 'react';

import dotBgDark from './assets/dot-bg.dark.png';
import dotBgLight from './assets/dot-bg.light.png';
import * as styles from './index.css';

export const HiveOtherPageLayout = ({ children }: { children: ReactNode }) => {
  const { resolvedTheme } = useTheme();
  const backgroundImage =
    resolvedTheme === 'dark' && dotBgDark ? dotBgDark : dotBgLight;

  return (
    <div
      className={styles.root}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {BUILD_CONFIG.isElectron ? (
        <div className={styles.draggableHeader} />
      ) : (
        <div className={styles.topNav}>
          <a href="/" rel="noreferrer" className={styles.hiveLogo}>
            <HiveLogo width={24} height={24} />
          </a>
        </div>
      )}

      {children}
    </div>
  );
};
